import React from "react";

import { DangerRoundRedIcon } from "../../../assets/icons";
import { PlanInputSelectDTO } from "../../../models/plan/plan.response";

interface PaymantCryptoTabProps {
    plan? : PlanInputSelectDTO;
}

const PaymantCryptoTab: React.FC<PaymantCryptoTabProps> = ({ plan }) => {

    return (
        <div className="modal-box-div">
            <div className="modal-box-header-div">
                <div className="modal-box-header-title">Kripto plaćanje</div>
                <div className="description-text">
                    Platite pomoću USDT kriptovalute<br />
                </div>
            </div>
            <div className="div-block-27">
                <div>
                    <div className="description-text">
                        Mreža<br />
                    </div>
                    <div className="input-div">
                        <div>TRC20 (Tron)</div>
                    </div>
                </div>
                <div>
                    <div className="description-text">
                        Wallet adresa<br />
                    </div>
                    <div className="input-div">
                        <div>TSsXDPTLXP5jCXFUm9ymnQcde1cjaNjBZi</div>
                    </div>
                </div>
                <div>
                    <div className="description-text">Iznos</div>
                    <div className="input-div">
                        <div>{(Number(plan?.price) * 0.011).toFixed(2) } USDT</div>
                    </div>
                </div>
            </div>
            <div className="modal-box-info-div warning">
                <div className="modal-box-info-header-div">
                    <img src={DangerRoundRedIcon} loading="lazy" alt="" className="icon-size-24" />
                    <div>Veoma važno:</div>
                </div>
                <ul role="list" className="modal-box-info-uo-list">
                    <li>
                        <div>Koristite isključivo TRC20 (Tron) mrežu</div>
                    </li>
                    <li>
                        <div>Ukoliko pošaljete sredstva preko druge mreže, sredstva će biti izgubljena</div>
                    </li>
                    <li>Nakon transakcije, pošaljite screenshot ili TX hash na: digitalmenudd@gmail.com</li>
                </ul>
            </div>
        </div>
    )
};

export default PaymantCryptoTab;